/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2022-01-04 15:58:49
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-04 15:59:52
 */
import i18n from "@/assets/lang"; // internationalization
/**
 * *2.用户名校验规则：
 * /^[a-zA-Z0-9_]{3,45}$/，保证全局唯一*
 */
export function checkUserName(rule, value, callback) {
  const reg = /^[a-zA-Z0-9_]{3,45}$/;
  if (value === "") {
    callback(new Error(i18n.t("userCenter.enterUsername")));
  } else if (reg.test(value)) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectUserName")));
  }
}

/* 姓名displayName */
import { strLengthCheck } from "@/utils/validate";
export function checkName(rule, value, callback) {
  if (value === "") {
    callback(new Error(i18n.t("userCenter.enterName")));
  } else if (strLengthCheck(value, 4, 30)) {
    callback();
  } else {
    callback(new Error(i18n.t("public.enterCorrectName")));
  }
}

/**
 * 密码规则
 */
export function validatePassword(rule, value, callback) {
  const reg = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(i18n.t("public.characterLimit")));
  }
}

/**
 * 验证字符长度length不超过64位,无字符规则
 */
export function lengthCheck(rule, str, callback) {
  const len = str.length;
  if (len > 64) {
    callback(new Error(i18n.t("public.characterLength")));
  } else {
    callback();
  }
}

/**
 * 验证编码
 */
export function validateCode(rule, value, callback) {
  const reg = rule.reg || /^[-_a-zA-Z0-9]+$/;
  if (reg.test(value)) {
    callback();
  } else if (!value) {
    callback();
  } else {
    callback(new Error(rule.reg ? rule.message : i18n.t("public.enterEnglishNumbers")));
  }
}

/**
 * 验证认证标识
 */
export function validateAuthenticationMark(rule, value, callback) {
  if (value.includes("$")) {
    callback(new Error(rule.reg ? rule.message : i18n.t("public.cannotUseCharacters")));
  } else {
    callback();
  }
}

/**
 * 验证认证秘钥
 */
export function validateAuthenticationKey(rule, value, callback) {
  if (value.length < 8 || value.length > 512) {
    callback(new Error(rule.reg ? rule.message : i18n.t("createAsset.validateAuthenticationKey")));
  } else {
    callback();
  }
}
